import { VFC, memo } from "react";

import SearchResults from "components/header/searchResults";

import { InstantSearch, Configure, SearchBox } from "react-instantsearch-dom";
import { useSearch } from "hooks/header/useSearch";

import { VscChromeClose } from "react-icons/vsc";
import "instantsearch.css/themes/satellite-min.css";

type SearchProps = {
  search: boolean;
  closeMenu: (type: "side" | "notif" | "search") => void;
};

const Search: VFC<SearchProps> = ({ search, closeMenu }) => {
  const { searchRef, indexName, searchClient } = useSearch(search);

  return (
    <div
      ref={searchRef}
      className={`${search ? "top-0" : "top-full"}
      bg-light dark:bg-dark fixed left-0 z-20 h-screen w-screen bg-opacity-90
     backdrop-blur-sm transition-[top] duration-500 dark:bg-opacity-90
      lg:top-4 lg:left-1/2 lg:h-auto lg:w-[36rem] lg:-translate-x-1/2 lg:!bg-opacity-0 lg:backdrop-blur-0
     `}
    >
      <div className="bg-light-50 dark:bg-dark-600 bg-opacity-40 p-4 dark:bg-opacity-40 lg:hidden">
        <button onClick={() => closeMenu("search")} className="ml-auto">
          <VscChromeClose className="mr-1" />
          閉じる
        </button>
      </div>
      <InstantSearch {...{ indexName, searchClient }}>
        <Configure hitsPerPage={5} />
        <SearchBox translations={{ placeholder: "記事のタイトル" }} />
        <SearchResults />
      </InstantSearch>
    </div>
  );
};

export default memo(Search);
